import { isObject } from "../../javascript-utils/is-type.js";
import { fetchFile } from "../fetch/fetch-file.js";
import { getGlobalLoaderOptions } from "./option-utils.js";
export function getFetchFunction(options, context) {
  const globalOptions = getGlobalLoaderOptions();
  const loaderOptions = options || globalOptions;
  if (typeof loaderOptions.fetch === 'function') {
    return loaderOptions.fetch;
  }
  if (isObject(loaderOptions.fetch)) {
    return url => fetchFile(url, loaderOptions.fetch);
  }
  if (context !== null && context !== void 0 && context.fetch) {
    return context === null || context === void 0 ? void 0 : context.fetch;
  }
  return fetchFile;
}
//# sourceMappingURL=get-fetch-function.js.map